module.exports = __webpack_public_path__ + "img/two.b732bee5.png";